import { ConfirmSheet } from '@/components/ConfirmSheet'
import {
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
} from '@/components/ModalSheet'
import { pluralize } from '@/utils/pluralization-util'

export interface AdvanceJobsDialogProps {
  showing: boolean
  jobsCount: number
  /**
   * How many of the jobs have not reached their advance date.
   */
  earlyAdvanceJobsCount: number
  isPending: boolean
  onConfirm: () => unknown
  onDecline: () => unknown
}

/**
 * Confirms advancing the selected pending jobs.
 */
export function AdvanceJobsDialog({
  showing,
  jobsCount,
  earlyAdvanceJobsCount,
  isPending,
  onConfirm,
  onDecline,
}: AdvanceJobsDialogProps) {
  const jobsLabel = `${jobsCount} ${pluralize('job', jobsCount)}`

  return (
    <ConfirmSheet
      yes={`Advance ${jobsLabel}`}
      showing={showing}
      isPending={isPending}
      onConfirm={onConfirm}
      onDecline={onDecline}
      confirmButtonTestId="advance-jobs-confirm-button"
      declineButtonTestId="advance-jobs-cancel-button"
    >
      <ModalSheetContentBlock>
        <ModalSheetContentTitle>Advance {jobsLabel}?</ModalSheetContentTitle>
        <ModalSheetContentDescription>
          Advancing moves the jobs out of Pending and cannot be undone.
          {earlyAdvanceJobsCount > 0 && (
            <>
              {' '}
              {earlyAdvanceJobsCount} of these have not reached their advance
              date and will be advanced early.
            </>
          )}
        </ModalSheetContentDescription>
      </ModalSheetContentBlock>
    </ConfirmSheet>
  )
}
